import 'bootstrap-notify';

import activeTabs from './activeTabs.js';
import aTable from './aTable.js';
import autoEnableSubmitButtons from './autoEnableSubmitButtons.js';
import browserHistory from './browserHistory.js';
import cards from './cards.js';
import confirmation from './confirmation.js';
import checkForChangedInput from './checkForChangedInput.js';
import checkboxInput from './checkboxInput.js';
import checkboxSelectAll from './checkboxSelectAll.js';
import countdown from './countdown.js';
import dataLinks from './dataLinks.js';
import datepicker from './datepicker.js';
import fileinput from './fileinput.js';
import format from './format.js';
import formIntlTelInput from './formIntlTelInput.js';
import formValidation from './formValidation.js';
import keyboardShortcuts from './keyboardShortcuts.js';
import modal from './modal.js';
import multiselect from './multiselect.js';
import permission from './permission.js';
import radioToggle from './radioToggle.js';
import redirect from './redirect.js';
import selectSearch from './selectSearch.js';
import selectToggle from './selectToggle.js';
import selectValue from './selectValue.js';
import showLoadingOnSubmit from './loading.js';
import testValue from './testValue.js';
import toggleDisabled from './toggleDisabled.js';
import togglePassword from './togglePassword.js';
import tooltips from './tooltips.js';

export default {
	init() {
	},
	finalize() {

		const target = document.querySelector('body');

		activeTabs.init(target);
		aTable.init(target);
		autoEnableSubmitButtons.init(target);
		browserHistory.init(target);
		cards.init(target);
		confirmation.init(target);
		checkForChangedInput.init(target);
		checkboxInput.init(target);
		checkboxSelectAll.init(target);
		countdown.init(target);
		dataLinks.init(target);
		datepicker.init();
		fileinput.init(target);
		format.init(target);
		formIntlTelInput.init(target);
		formValidation.init(target);
		keyboardShortcuts.init(target);
		modal.init(target);
		multiselect.init(target);
		permission.init(target);
		radioToggle.init(target);
		redirect.init(target);
		selectSearch.init();
		selectToggle.init(document.querySelectorAll('body'));
		selectValue.init(target);
		showLoadingOnSubmit.init();
		testValue.init(target);
		toggleDisabled.init(target);
		togglePassword.init(target);
		tooltips.init();
	},
};
